export default {
	GET_GOODS_TYPE_LIST: (state, data) => {
		state.list = data;
	},
	GET_GOODS_LIST: (state, data) => {
		state.goodsList = data;
	},
	GET_BANNER_LIST: (state, data) => {
		state.bannerList = data;
	},
	GET_ORDER_LIST: (state, data) => {
		state.orderList = data;
	},
	GET_ORDER_STATISTICS_INFO: (state, data) => {
		state.statistics = data;
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/vmall/mutations.js